module.exports = __webpack_public_path__ + "media/images/responsive/fairs/point_number-560a138a08c841633728f700e862c4ed.svg";